import React from "react";

const TeacherAchievements = ({teacher}) => {
    return (
        <div>
            <p className="sub-menu-header">Awards & Achievements</p>
            <ol style={{marginTop: '2em'}}>
                {
                    teacher.achievements?.map((a) => (
                        <li className="teacher-data-item">                        
                            <h3>{a.title}</h3>
                            {a.description && (<h6>{a.description}</h6>)}
                        </li>
                    ))
                }
            </ol>
        </div>
    )
};

export default TeacherAchievements;
